import { useEffect, useState } from "react";
import { Button, ButtonGroup, Col, Container, Nav, Row } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import ProjectAPI from "../../api/ProjectsAPI";
import GitHubLogo from "../../assets/github-mark.png";
import urlLink from '../../components/assets/expand-arrows.png';
import BackButton from "../../components/Buttons/BackButton";
import ParagraphBody from "../../components/ParagraphBody";
import Group from "../../components/Group";
import Toolbar from "../../components/Toolbar/Toolbar";
import LinkIcon from "../../components/Link/LinkIcon";
import HTMLRender from "../../components/content/HTMLRender";

interface ProjectRecordObject{
    name:string;
    description:string;
    url:string;
    externalLink:string;
}
type Props={
    preview?:boolean;
    record:ProjectRecordObject|Record<string,any>|null;
}
export default function ProjectRecord(props:Props){
    const {id}=useParams();
    const api=new ProjectAPI();
    const [load,setLoad]=useState(false);
    const [project,setProject]=useState<ProjectRecordObject|Record<string,any>>({
        name:"",
        description:"",
        url:"",
        externalLink:''
    });
    const [showLinks,setLinks]=useState(false);

    const getProject=async ()=>{
        if(props.record==null){
            try{
                const project=await api.getProject(id);
                setProject(project);
                setLoad(true);
                displayLinks(project.url,project.externalLink);
                api.metricCount(id,'view');
            }catch(err){
                
            } 
        }else{
            setProject(props.record);
            setLoad(true);
            displayLinks(props.record.url,props.record.externalLink);
            if(!props.preview) api.metricCount(id,'view');
        }
    }
    const displayLinks=(url:string,link:string)=>{
        if(url){
            setLinks(true);
        }
        if(link) setLinks(true);
    }
    const repositoryHandle=async()=>{
        if(!props.preview){
            const request=await api.metricCount(id,'click');
        }
    }
    const externalHandle=async()=>{
        if(!props.preview) {
            const request=await api.metricCount(id,'externalLink');
        }
  }
    useEffect(() => {
        getProject();
    },[]);
    
    return(
        <div>
        <Group>
        <Row>
        <Col id="BackSection" xs={5} md={2}>
        <div className="">
        {load?
        <BackButton disabled={props.preview} url={"/projects"}/>
        :null}
        </div>
        </Col>
        <Col  md={8}>
        <div className="ProjectTitle">
        <h1>{project.name}</h1>
        {showLinks?
        <Toolbar backgroundColor={'#F0FFFF'}>
        {project.url!=""?
        <LinkIcon>
        <a href={project.url} onClick={repositoryHandle}><img src={GitHubLogo} width={25} height={25} alt="GitRepo"/></a>
        </LinkIcon>
        :null}
        {project.externalLink?
        <LinkIcon>
         <a href={project.externalLink} onClick={externalHandle}><img src={urlLink} width={25} height={25} alt="Link"/></a>
        </LinkIcon>
        :null}
        </Toolbar>
        :null}
        </div>
        {!project.description.startsWith('<')&&!project.description.endsWith('>')?
        <ParagraphBody value={project.description}/>
        :null}
        {project.description.startsWith('<')&&project.description.endsWith('>')?
        <HTMLRender html={project.description} style={{paddingLeft:'19px'}}/>
        :null}
        </Col>
        </Row>
        </Group>

        </div>
    );
}